import dayjs from "dayjs";

export const financeTableParser = (value: string | undefined) => {
  if (!value || value.trim() === "") {
    return "0";
  } else {
    return value.replace(",", "").replace(".", "").replace("0-", "-");
  }
};

/**@description Функция для генерации данных селектора дат в финансах */
export const generateYearSelectOptions = () => {
  const res: { value: string; label: number }[] = [];
  for (let i = 1; i < 7; i++) {
    res.push({
      label: dayjs().get("year") - i,
      value: dayjs().subtract(i, "year").format("YYYY:MM:DD HH:mm:ss"),
    });
  }

  return res;
};

export const yearSelectOptions = generateYearSelectOptions();
